<script>
  // Перенос ProgressBar из lib/ui.tsx — трек + золотой градиентный филл.
  export let value = 0;
  export let large = false;
  $: pct = Math.max(0, Math.min(100, value));
</script>

<div class={'ui-prog' + (large ? ' lg' : '')}><div class="fill" style="width:{pct}%"></div></div>
